import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    configuration: translate({ id: 'orders.form.orderInformation' }),
    communication: translate({ id: 'orders.form.notifications' }),
    execution: translate({ id: 'orders.form.executionEvents' }),
    notificationTabDisabledInSimulationTooltip: translate({
      id: 'v3.orders.form.notifications.disabledInSimulation',
    }),
    notificationTabDisabledInEditModeTooltip: translate({
      id: 'v3.orders.form.notifications.disabledInEditMode',
    }),
    executionTabDisabledInSimulationTooltip: translate({
      id: 'v3.orders.form.executionEvents.disabledInSimulation',
    }),
    executionTabDisabledInEditModeTooltip: translate({
      id: 'v3.orders.form.executionEvents.disabledInEditMode',
    }),
  }))

  return api
}
